import React, { useState, useEffect, useRef } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import LogoDesktop from "../assets/images/Guten-Stack-horizontal-wordmark.webp";
import LogoMobile from "../assets/images/Guten-Stack-mark.webp";

import "../styles/navbar.css";

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef(null);

  useEffect(() => {
    const fetchUserData = async () => {
      if (auth.currentUser) {
        const userDocRef = doc(db, "users", auth.currentUser.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          setUser(userDoc.data());
        }
      }
    };

    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        fetchUserData();
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeMobile = () => setMobileMenuOpen(false);

  const profilePath = user?.username?.trim()
    ? `/${user.username}`
    : "/admin";

  return (
    <nav className="navbar">

      {/* Logo */}
      <div className="navbar-logo">
        <Link to="/">
          <img src={LogoDesktop} alt="GutenStack" className="navbar-logo-desktop" />
          <img src={LogoMobile} alt="GutenStack" className="navbar-logo-mobile" />
        </Link>
      </div>

      <div className="navbar-button-container">
        {/* Desktop nav links */}
        <Link to="/about" className="navbar-link hide-on-mobile">About</Link>
        <Link to="/personas" className="navbar-link hide-on-mobile">Book Persona</Link>

        <Link to="/release-notes" className="navbar-link hide-on-mobile">Updates</Link>

        {user ? (
          <>
            <Link to={profilePath} className="navbar-profile hide-on-mobile">
              <img src={user.profilePic || "/images/public-profile.png"} alt="Profile" className="profile-pic" />
            </Link>
          </>
        ) : (
          <>
            <Link to="/signup?tab=signin" className="navbar-link hide-on-mobile">Sign In</Link>
            <Link to="/signup?tab=signup" className="navbar-button hide-on-mobile">Sign Up</Link>
          </>
        )}

        {/* Mobile: avatar/sign-in + hamburger */}
        <div className="mobile-nav-right show-on-mobile">
          {user ? (
            <Link to={profilePath} className="navbar-profile">
              <img src={user.profilePic || "/images/public-profile.png"} alt="Profile" className="profile-pic" />
            </Link>
          ) : (
            <Link to="/signup?tab=signin" className="navbar-link">Sign In</Link>
          )}

          <div
            className="mobile-hamburger"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            ref={mobileMenuRef}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>

            <div className={`mobile-dropdown ${mobileMenuOpen ? "open" : ""}`}>
              <ul>
                <li><Link to="/about" onClick={closeMobile}>About</Link></li>
                <li><Link to="/personas" onClick={closeMobile}>Persona</Link></li>
                <li><Link to="/kpis" onClick={closeMobile}>KPIs</Link></li>
                <li><Link to="/release-notes" onClick={closeMobile}>Updates</Link></li>
                {!user && (
                  <>
                    <li><Link to="/signup?tab=signin" onClick={closeMobile}>Sign In</Link></li>
                    <li><Link to="/signup?tab=signup" onClick={closeMobile}>Sign Up</Link></li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
